import axios from "axios";
import {getMinuteForm} from "../main-specialist-video/main-specialist-video";
import {initExerciseCard} from "../exercise-card/exercise-card";

const MOBILE_BREAKPOINT = 968;
const DATA_ATTR = 'data-main-exercises';
const CLASS_PREFIX = 'main-exercises';

export function isMobile() {
    return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;
}

const container = document.querySelector(`[${DATA_ATTR}]`);
if (container) {
    initMainExercises(container);
}

function initMainExercises(container) {
    const template = document.querySelector(`[${DATA_ATTR}-container-template]`);
    const templateSpecialist = document.querySelector(`[${DATA_ATTR}-specialist-container-template]`);
    const loader = container.querySelector(`[${DATA_ATTR}-loader]`);
    const list = container.querySelector(`[${DATA_ATTR}-ex-list]`);
    const loadMoreBtn = container.querySelector(`[${DATA_ATTR}-load-more]`);

    let page = 1;
    const perPage = 6;
    let hasMore = true;
    let isLoading = false;

    const filters = {
        tags: [],
        demands: [],
        directions: [],
        exercise_type: [],
        is_free: false,
        is_institute: false,
        only_serials: false,
        only_university: false,
    };
    const tempFilters = {};

    init();

    async function init() {
        setupFilters(container);
        await fetchAndRender();

        loadMoreBtn.addEventListener('click', fetchAndRender);
    }


    async function fetchAndRender() {
        if (isLoading || !hasMore) return;
        isLoading = true;
        toggleLoader(true);

        try {
            const {exercises: newItems, hasMore: more} = await fetchExercises(page, perPage, filters);
            newItems.forEach(item => initExerciseCard(list, item));
            hasMore = more;
            page += 1;
            loadMoreBtn.style.display = hasMore ? 'flex' : 'none';
        } catch (err) {
            console.error('Error loading exercises:', err);
        } finally {
            toggleLoader(false);
            isLoading = false;
        }
    }

    function toggleLoader(show) {
        loader.style.display = show ? 'flex' : 'none';
    }

    async function fetchExercises(page, perPage, filters) {
        const params = {page, per_page: perPage};


        if (filters.tags.length && !filters.tags.includes('all')) {
            params.tag = filters.tags.join(',');
        }
        if (filters.directions.length && !filters.directions.includes('all')) {
            params.directions = filters.directions.join(',');
        }
        if (filters.demands.length && !filters.demands.includes('all')) {
            params.demand = filters.demands.join(',');
        }
        if (filters.exercise_type.length && !filters.exercise_type.includes('all')) {
            params.type = filters.exercise_type.join(',');
        }
        if (filters.is_free) {
            params.is_free = true;
        }
        if (filters.is_institute) {
            params.is_institute = true;
        }
        if (filters.only_serials) {
            params.only_serials = true;
        }
        if (filters.only_university) {
            params.only_university = true;
        }

        const query = new URLSearchParams(params).toString();
        const url = `/api/exercises?${query}`;
        const {data} = await axios.get(url);


        console.log('EXERCISES', data);
        return {
            exercises: data.data || [],
            hasMore: data.has_more,
        };
    }


    function setupFilters(container) {
        const filterEls = container.querySelectorAll(`[${DATA_ATTR}-filter]`);
        filterEls.forEach(el => bindFilter(el));

        document.addEventListener('click', e => {
            if (!e.target.closest(`[${DATA_ATTR}-filter]`)) {
                closeOpenLists();
            }
        });
    }

    function bindFilter(filterEl) {
        const type = filterEl.dataset.mainExercisesFilterType;
        const key = filterEl.dataset.mainExercisesFilter;
        const header = filterEl.querySelector(`[${DATA_ATTR}-header]`);

        header.addEventListener('click', e => {
            e.stopPropagation();
            if (type === 'single') {
                toggleSingle(filterEl, key);
            } else {
                toggleList(filterEl, key);
            }
        });

        if (type === 'list') {
            setupListControls(filterEl, key);
        }
    }

    function toggleSingle(el, key) {
        const active = el.classList.toggle('active');
        filters[key] = active;
        updateFilterTitle(el);
        resetAndFetch();
    }

    function toggleList(el, key) {
        const open = el.classList.toggle('open');
        if (open) {
            closeAllLists();
            tempFilters[key] = filters[key].slice() || ['all'];
            el.classList.add('open');
        } else if (!isMobile()) {
            applyTemp(el, key);
        }
    }

    function setupListControls(el, key) {
        const opts = el.querySelectorAll(`[${DATA_ATTR}-filter-option]`);
        opts.forEach(opt => {
            opt.addEventListener('click', e => {
                e.stopPropagation();
                const val = opt.dataset.mainExercisesFilterOption;
                updateTempList(key, val);
                syncOptionUI(el, tempFilters[key]);
            });
        });
        const resetBtn = el.querySelector(`[${DATA_ATTR}-filter-reset]`);
        const acceptBtn = el.querySelector(`[${DATA_ATTR}-filter-accept]`);
        const closeBtn = el.querySelector(`[${DATA_ATTR}-filter-close]`);

        resetBtn?.addEventListener('click', e => {
            e.stopPropagation();
            tempFilters[key] = ['all'];
            syncOptionUI(el, tempFilters[key]);
        });
        acceptBtn?.addEventListener('click', e => {
            e.stopPropagation();
            applyTemp(el, key);
        });
        closeBtn?.addEventListener('click', e => {
            e.stopPropagation();
            el.classList.remove('open');
        });
    }

    function updateTempList(key, val) {
        const arr = tempFilters[key] = tempFilters[key] || [];
        if (val === 'all') {
            arr.splice(0, arr.length, 'all');
        } else {
            const allIdx = arr.indexOf('all');
            if (allIdx > -1) arr.splice(allIdx, 1);
            const idx = arr.indexOf(val);
            idx > -1 ? arr.splice(idx, 1) : arr.push(val);
            if (arr.length === 0) arr.push('all');
        }
    }

    function applyTemp(el, key) {
        el.classList.remove('open');
        filters[key] = [...(tempFilters[key] || ['all'])];
        updateFilterTitle(el);
        resetAndFetch();
    }

    function closeAllLists() {
        container.querySelectorAll(`[${DATA_ATTR}-filter].open`).forEach(el => el.classList.remove('open'));
    }

    function closeOpenLists() {
        let applied = false;
        container.querySelectorAll(`[${DATA_ATTR}-filter].open`).forEach(el => {
            const key = el.dataset.mainExercisesFilter;
            const type = el.dataset.mainExercisesFilterType;
            if (type === 'list' && !isMobile()) {
                applyTemp(el, key);
                applied = true;
            } else {
                el.classList.remove('open');
            }
        });
        if (applied) resetAndFetch();
    }

    function syncOptionUI(el, values) {
        el.querySelectorAll(`[${DATA_ATTR}-filter-option]`).forEach(opt => {
            opt.classList.toggle('active', values.includes(opt.dataset.mainExercisesFilterOption));
        });
    }

    function updateFilterTitle(el) {
        const key = el.dataset.mainExercisesFilter;
        const name = el.dataset.mainExercisesFilterName;
        const title = el.querySelector(`[${DATA_ATTR}-title]`);
        const sel = filters[key];

        if (typeof sel === 'boolean') {
            title.textContent = sel ? `${name}: Да` : name;
        } else if (!sel.length || sel.includes('all')) {
            title.textContent = `Все ${name.toLowerCase()}`;
        } else if (sel.length === 1) {
            const opt = el.querySelector(`[${DATA_ATTR}-filter-option="${sel[0]}"]`);
            title.textContent = opt?.textContent || `${name}: 1`;
        } else {
            title.textContent = `${name}: ${sel.length}`;
        }
    }

    function resetAndFetch() {
        page = 1;
        hasMore = true;
        list.innerHTML = '';
        fetchAndRender();
    }
}
